const ALLOWED_STATUSES = new Set([
  'sent',
  'processing',
  'send-failed',
  'accessed',
  'read',
  'replied',
  'expired',
  'revoked',
])

const ALLOWED_METHODS = new Set(['dlp', 'elective'])

const DATE_RANGE_MS = {
  '24h': 24 * 60 * 60 * 1000,
  '7d': 7 * 24 * 60 * 60 * 1000,
  '30d': 30 * 24 * 60 * 60 * 1000,
  '60d': 60 * 24 * 60 * 60 * 1000,
  '90d': 90 * 24 * 60 * 60 * 1000,
}

export const buildTrackedEmailsQuery = (filters = {}) => {
  const params = {}

  if (filters.search) {
    params.q = filters.search
  }

  // A card window always has an end; under All time it has no start.
  if (filters.revokedTo) {
    // The Revoked card counts by revocation time, including mail sent before the window.
    if (filters.revokedFrom) params.revokedFrom = filters.revokedFrom
    params.revokedTo = filters.revokedTo
  } else if (filters.to) {
    if (filters.from) params.from = filters.from
    params.to = filters.to
  } else if (filters.dateRange && filters.dateRange !== 'all') {
    const rangeMs = DATE_RANGE_MS[filters.dateRange]
    if (rangeMs) {
      params.from = new Date(Date.now() - rangeMs).toISOString()
      params.to = new Date().toISOString()
    }
  }

  if (ALLOWED_METHODS.has(filters.method)) {
    params.method = filters.method
  }

  if (filters.statuses?.length > 0) {
    const statuses = filters.statuses.filter((status) => ALLOWED_STATUSES.has(status))
    if (statuses.length > 0) {
      params.status = statuses
    }
  }

  if (filters.policiesAvailable && filters.triggers?.length > 0) {
    params.triggeredPolicies = filters.triggers
  }

  if (filters.cursor) {
    params.cursor = filters.cursor
  }

  if (filters.size) {
    params.size = filters.size
  }

  return params
}
